// -----------------------APPEARANCE-----------------------
export var DNAButtonAppearanceEnum;
(function (DNAButtonAppearanceEnum) {
    DNAButtonAppearanceEnum["filled"] = "filled";
    DNAButtonAppearanceEnum["outline"] = "outline";
    DNAButtonAppearanceEnum["ghost"] = "ghost";
})(DNAButtonAppearanceEnum || (DNAButtonAppearanceEnum = {}));
export const DNAButtonAppearanceKeys = Object.keys(DNAButtonAppearanceEnum);
// --------------------------STATUS--------------------------
export var DNAButtonStatusEnum;
(function (DNAButtonStatusEnum) {
    DNAButtonStatusEnum["primary"] = "primary";
    DNAButtonStatusEnum["secondary"] = "secondary";
    DNAButtonStatusEnum["subtle"] = "subtle";
    DNAButtonStatusEnum["success"] = "success";
    DNAButtonStatusEnum["warning"] = "warning";
    DNAButtonStatusEnum["danger"] = "danger";
    DNAButtonStatusEnum["transparent"] = "transparent";
    DNAButtonStatusEnum["tertiary"] = "tertiary";
})(DNAButtonStatusEnum || (DNAButtonStatusEnum = {}));
export const DNAButtonStatusKeys = Object.keys(DNAButtonStatusEnum);
// --------------------------SIZE--------------------------
export var DNAButtonSizeEnum;
(function (DNAButtonSizeEnum) {
    DNAButtonSizeEnum["sm"] = "sm";
    DNAButtonSizeEnum["md"] = "md";
    DNAButtonSizeEnum["lg"] = "lg";
    DNAButtonSizeEnum["xl"] = "xl";
})(DNAButtonSizeEnum || (DNAButtonSizeEnum = {}));
export const DNAButtonSizeKeys = Object.keys(DNAButtonSizeEnum);
//# sourceMappingURL=DNAButton.types.js.map